import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useSelector } from 'react-redux';
import { jwtDecode } from 'jwt-decode';
import './DailyOperatorsInfo.css';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import ModalCerrarServicio from '../components/ModalCerrarServicio';
import ModalConcluirServicio from '../components/ModalConcluirServicio';
import jsPDF from 'jspdf';
import logo from '../assets/gorion.png'; // Ruta a tu logo
import { current } from '@reduxjs/toolkit';

const moment = require('moment-timezone');

const DailyOperatorsInfo = () => {
  const [operators, setOperators] = useState([]);
  const [filteredOperators, setFilteredOperators] = useState([]);
  const [searchSiglas, setSearchSiglas] = useState(''); // Para el campo de búsqueda
  const [selectedServices, setSelectedServices] = useState([]);
  const [selectedOperator, setSelectedOperator] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [showCerrarServicioModal, setShowCerrarServicioModal] = useState(false);
  const [selectedService, setSelectedService] = useState(null);
  const [isModalTransferOpen, setIsModalTransferOpen] = useState(false);
  const [siglas, setSiglas] = useState('');
  const [noColaboradorDestino, setNoColaboradorDestino] = useState('');
  const [loadingTransfer, setLoadingTransfer] = useState(false);
  const [servicioTransferencia, setServicioTransferencia] = useState(null);
  const [operadoresDisponibles, setOperadoresDisponibles] = useState([]);
  const [isModalSeleccionOpen, setIsModalSeleccionOpen] = useState(false);
  const [isConcluirModalOpen, setIsConcluirModalOpen] = useState(false);

  const token = useSelector((state) => state.auth.token);
  const decoded = token ? jwtDecode(token) : null;
const estacionUsuario = decoded?.estacion?.trim().toUpperCase();



  useEffect(() => {
    const fetchOperators = async () => {
      try {
        const response = await axios.get(
          'https://orionadministracion.com/api/servicios/daily-info',
          { headers: { Authorization: `Bearer ${token}` } }
        );

        // Filtramos por estación directamente aquí
        console.log("Datos recibidos:", response.data); // <-- Añade esto

const dataFiltrada = response.data.filter(
  (op) => op.estacion?.trim().toUpperCase() === estacionUsuario
);


        setOperators(dataFiltrada);
        setFilteredOperators(dataFiltrada)
      } catch (error) {
        console.error('Error al obtener la información de operadores:', error);
      }
    };

    

    if (token) {
      fetchOperators();
    }
  }, [token, estacionUsuario]);

  const handleSearchSiglas = (event) => {
    const searchValue = event.target.value;
    setSearchSiglas(searchValue);
    
    if (searchValue === '') {
      // Si no hay texto en el campo de búsqueda, mostramos todos los operadores
      setFilteredOperators(operators);
    } else {
      // Filtrar los operadores por siglas
      const filtered = operators.filter((operator) =>
        operator.siglas.toLowerCase().includes(searchValue.toLowerCase())
      );
      setFilteredOperators(filtered);
    }
  };

  const abrirModalSeleccionOperador = async () => {
    try {
      setLoadingTransfer(true);
      const response = await axios.get(
        'https://orionadministracion.com/api/bitacora/en-turno-detalles',
        { headers: { Authorization: `Bearer ${token}` } }
      );
      setOperadoresDisponibles(response.data);
      setLoadingTransfer(false);
    } catch (error) {
      console.error('Error al cargar operadores:', error);
      toast.error('Hubo un error al cargar los operadores disponibles.', {
        position: 'top-right',
        autoClose: 3000,
      });
      setLoadingTransfer(false);
    }
  };

  const handleCardClick = async (operator) => {
    try {
      const response = await axios.get(
        `https://orionadministracion.com/api/servicios/colaborador/${operator.noColaborador}`,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      setSelectedServices(response.data);
      setSelectedOperator(operator);
      setShowModal(true);
    } catch (error) {
      console.error('Error al obtener servicios:', error);
    }
  };

  const refreshServices = async (operator) => {
    try {
      const response = await axios.get(
        `https://orionadministracion.com/api/servicios/colaborador/${operator.noColaborador}`,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      setSelectedServices(response.data);
    } catch (error) {
      console.error('Error al actualizar los servicios:', error);
    }
  };

  const transferirServicio = async () => {
    if (!noColaboradorDestino) {
      toast.warning('Primero debe seleccionar un operador válido.', {
        position: 'top-right',
        autoClose: 3000,
      });
      return;
    }
    try {
      setLoadingTransfer(true);
      await axios.put(
        `https://orionadministracion.com/api/servicios/${servicioTransferencia.noServicio}`,
        { noColaborador: noColaboradorDestino },
        {
          headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json',
          },
        }
      );
      toast.success('Servicio transferido exitosamente.', {
        position: 'top-right',
        autoClose: 3000,
      });
      setTimeout(() => {
        window.location.reload();
      }, 3000);
      setIsModalTransferOpen(false);
    } catch (error) {
      console.error('Error al transferir servicio:', error);
      toast.error('Hubo un error al transferir el servicio.', {
        position: 'top-right',
        autoClose: 3000,
      });
    } finally {
      setLoadingTransfer(false);
    }
  };

  const abrirModalConcluir = (servicio) => {
    setSelectedService(servicio);
    setIsConcluirModalOpen(true);
  };

  const closeModal = () => {
    setShowModal(false);
    setSelectedServices([]);
    setSelectedOperator(null);
  };

  const cerrarModalTransferencia = () => {
    setIsModalTransferOpen(false);
    setServicioTransferencia(null);
    setSiglas('');
    setNoColaboradorDestino('');
  };

  const abrirModalTransferencia = () => {
    setIsModalTransferOpen(true);
    setSiglas('');
    setNoColaboradorDestino('');
  };

  // Para el modal de selección de operador (transferencia)
  const filteredOperadores = operadoresDisponibles.filter((operador) => {
    const searchLower = operador.nombreCompleto.toLowerCase();
    return searchLower.includes(siglas.toLowerCase());
  });

  const handleReprintTicket = async (service) => {
    try {
      const response = await axios.get(
        `https://orionadministracion.com/api/operadores/${service.noColaborador}`,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      const operadorAsign = response.data;
    
    // Crear el documento PDF
    const doc = new jsPDF({
      orientation: 'portrait',
      unit: 'mm',
      format: [58, 120], // 58mm de ancho, altura variable
    });
  
    // Agregar logo
    doc.addImage(logo, 'PNG', 4, 4, 50, 20); // X, Y, Ancho, Alto
  
    // Fecha del servicio
    doc.setFontSize(12);
    doc.text(`Fecha: ${moment().tz('America/Mexico/City').format('YYYY-MM-DD HH:mm:ss')}`, 4, 30);
  
    // Agregar detalles del ticket
    doc.setFontSize(10);
    doc.text(`Aerolinea: ${service.aerolinea}`, 4, 35);
    doc.text(`No. Vuelo: ${service.noVuelo}`, 4, 40);
    const nombreOperador = `Operador: ${operadorAsign.nombre} ${operadorAsign.apellidos} - ${service.noColaborador}`;
    const splitOperatorText = doc.splitTextToSize(nombreOperador, 50)
    doc.text(splitOperatorText, 4, 45)
    doc.text(`No. TIA: ${operadorAsign.tia || '2502432'}`, 4, 55);
    doc.text(`Silla: ${service.sillaRuedas}`, 4, 60);
  
    // Nombre del pasajero y otros detalles
    const passengerText = `Pasajero: ${service.nombrePax}`;
    const maxWidth = 50;
    const splitPassengerText = doc.splitTextToSize(passengerText, maxWidth);
    let currentY = 70;
    doc.text(splitPassengerText, 4, currentY);
  
    // Mensaje final
    doc.setFontSize(12);
    doc.text('------------------------------------------', 4, currentY + 10);
    doc.text('La calidad en el servicio,', 4, currentY + 15);
    doc.text('     nos caracteriza', 4,currentY +20 )
    doc.text('Servicio gratuito', 4, currentY + 25);
    doc.setFontSize(9);
    doc.text('Quejas: 55-2729-1171', 4, currentY + 30);
    doc.setFontSize(12);
    doc.text('-----------------------------------------', 4, currentY + 35);
  
    // Abrir el PDF en una nueva pestaña
    const pdfURL = doc.output('bloburl');
    window.open(pdfURL, '_blank');
  }catch (error){
       toast.error('Error al imprimir el servicio', {
              position: 'top-right',
              autoClose: 3000,
            });
  }
  };
  

  return (
    <div className="daily-operators-container">
      <ToastContainer />
      <h3 style={{ marginTop: 10 }}>
  Estación actual: {estacionUsuario || 'No detectada'}
</h3>


      <h1>Operadores en Bitácora</h1>
      {/* Campo de búsqueda */}
      <div className="search-bar">
        <input
          type="text"
          value={searchSiglas}
          onChange={handleSearchSiglas}
          placeholder="Buscar por siglas..."
          className="search-input"
        />
      </div>
      <div className="operators-grid">
        {filteredOperators.map((operator, index) => (
          <div className="operator-card" key={index} onClick={() => handleCardClick(operator)}>
          <div className="operator-row top">
            <span>{operator.siglas}</span>
            <span>{operator.nombreCompleto}</span>
            <span>{operator.noColaborador}</span>
          </div>
          <div className="operator-row bottom">
            <span>Servicios en curso: {operator.serviciosEnCurso}</span>
          </div>
          <div className="operator-row bottom">
            <span>Servicios concluidos: {operator.serviciosConcluidos}</span>
          </div>
        </div>
        ))}
      </div>

      {showModal && (
  <div className="modal-overlay" onClick={closeModal}>
    <div className="modal" onClick={(e) => e.stopPropagation()}>
      <div className="modal-header">
        <h2>Servicios de {selectedOperator?.nombreCompleto}</h2>
      </div>
      <div className="modal-body">
        <div className="modal-services-grid">
          {selectedServices.map((service) => (
            <div key={service.noServicio} className="modal-card">
            <p><strong>No. Servicio:</strong> {service.noServicio}</p>
            <p><strong>Tipo de servicio:</strong> {service.tipoService}</p>
            <p><strong>Nombre Pax:</strong> {service.nombrePax}</p>
            <p><strong>Aerolínea:</strong> {service.aerolinea}</p>
            <p><strong>Vuelo:</strong> {service.noVuelo}</p>
            <p><strong>Silla Ruedas:</strong> {service.sillaRuedas}</p>
            <p><strong>ETA:</strong> {service.eta}</p>
            <p><strong>Asiento:</strong> {service.noAsiento}</p>
            <p><strong>Tipo de Vuelo:</strong> {service.tipoVuelo}</p>
            <p><strong>Hora Inicio:</strong> {service.horaInicio}</p>
            <p><strong>Hora Fin:</strong> {service.horaFin || 'Sin finalizar'}</p>
          
            {service.statusServicio === 'EN CURSO' && (
              <div className="service-actions">
                {service.tipoService === 'MOSTRADOR' && (
                  <>
                    <button
                      className="btn-close-service"
                      onClick={() => {
                        setSelectedService(service);
                        setShowCerrarServicioModal(true);
                      }}
                    >
                      Cerrar Servicio
                    </button>
                    <button
                      className="btn-transfer-service"
                      onClick={() => {
                        setServicioTransferencia(service);
                        setIsModalTransferOpen(true);
                      }}
                    >
                      Transferir Servicio
                    </button>
                  </>
                )}
                {service.tipoService === 'LLEGADAS' && (
                  <>
                    <div className="service-actions">
                      <button
                        className="btn-complete-close-service"
                        onClick={() => {
                          setSelectedService(service);
                          setIsConcluirModalOpen(true);
                        }}
                      >
                        Completar y Cerrar Servicio
                      </button>
                      <button
                        className="btn-no-requerido"
                        onClick={async () => {
                          try {
                            await axios.put(
                              `https://orionadministracion.com/api/servicios/${service.noServicio}`,
                              {
                                observaciones: 'NO REQUERIDO AEROLINEA',
                                statusServicio: 'CANCELADO',
                              },
                              {
                                headers: {
                                  Authorization: `Bearer ${token}`,
                                  'Content-Type': 'application/json',
                                },
                              }
                            );
                            toast.success(
                              'Servicio actualizado: No requerido aerolínea.',
                              { position: 'top-right', autoClose: 3000 }
                            );
                            refreshServices(selectedOperator);
                          } catch (error) {
                            console.error('Error al actualizar servicio:', error);
                            toast.error(
                              'Hubo un error al actualizar el servicio.',
                              { position: 'top-right', autoClose: 3000 }
                            );
                          }
                        }}
                      >
                        No requerido aerolínea
                      </button>
                      <button
                        className="btn-no-requerido"
                        onClick={async () => {
                          try {
                            await axios.put(
                              `https://orionadministracion.com/api/servicios/${service.noServicio}`,
                              {
                                observaciones: 'NO REQUERIDO PASAJERO',
                                statusServicio: 'CANCELADO',
                              },
                              {
                                headers: {
                                  Authorization: `Bearer ${token}`,
                                  'Content-Type': 'application/json',
                                },
                              }
                            );
                            toast.success(
                              'Servicio actualizado: No requerido pasajero.',
                              { position: 'top-right', autoClose: 3000 }
                            );
                            refreshServices(selectedOperator);
                          } catch (error) {
                            console.error('Error al actualizar servicio:', error);
                            toast.error(
                              'Hubo un error al actualizar el servicio.',
                              { position: 'top-right', autoClose: 3000 }
                            );
                          }
                        }}
                      >
                        No requerido pasajero
                      </button>
                    </div>
                  </>
                )}
          
                {/* Icono de impresora solo si el servicio no está concluido */}
                {service.statusServicio !== 'CONCLUIDO' && (
                  <button
                    className="btn-reprint-service"
                    onClick={() => handleReprintTicket(service)}
                  >
                    <i className="fa fa-print"></i> Reimprimir Ticket
                  </button>
                )}
              </div>
            )}
          </div>
          
          ))}
        </div>
      </div>
      <div className="modal-footer">
        <button className="close-button" onClick={closeModal}>
          Cerrar
        </button>
      </div>
    </div>
  </div>
)}


      {showCerrarServicioModal && (
        <ModalCerrarServicio
          servicio={selectedService}
          onClose={() => {
            setShowCerrarServicioModal(false);
            refreshServices(selectedOperator);
          }}
        />
      )}

      {isModalTransferOpen && (
        <div className="modal-overlay">
          <div className="modal">
            <h2>Transferir Servicio</h2>
            <div className="modal-content">
              <label htmlFor="siglas">Siglas del operador:</label>
              <input
                type="text"
                id="siglas"
                value={siglas}
                readOnly
                placeholder="Seleccione las siglas del operador"
              />
              <button
                className="btn-select"
                onClick={() => {
                  setIsModalSeleccionOpen(true);
                  abrirModalSeleccionOperador();
                }}
              >
                Seleccionar
              </button>
              {noColaboradorDestino && (
                <div className="operator-info">
                  <p>
                    <strong>Número de colaborador:</strong> {noColaboradorDestino}
                  </p>
                </div>
              )}
              <button
                className="btn-transfer"
                onClick={transferirServicio}
                disabled={!noColaboradorDestino || loadingTransfer}
              >
                {loadingTransfer ? 'Transfiriendo...' : 'Confirmar Transferencia'}
              </button>
            </div>
            <button className="btn-cancel" onClick={() => setIsModalTransferOpen(false)}>
              Cancelar
            </button>
          </div>
        </div>
      )}

      {isModalSeleccionOpen && (
        <div className="modal-overlay">
          <div className="modal">
            <h2>Seleccionar Operador</h2>
            <div className="modal-content">
              {loadingTransfer ? (
                <p>Cargando operadores...</p>
              ) : (
                operadoresDisponibles.map((operador) => (
                  <div
                    key={operador.noColaborador}
                    className="operador-item"
                    onClick={() => {
                      setSiglas(operador.siglas);
                      setNoColaboradorDestino(operador.noColaborador);
                      setIsModalSeleccionOpen(false);
                      toast.success(`Operador seleccionado: ${operador.nombreCompleto}`, {
                        position: 'top-right',
                        autoClose: 3000,
                      });
                    }}
                  >
                    <p>
                      <strong>Siglas:</strong> {operador.siglas}
                    </p>
                    <p>
                      <strong>Nombre:</strong> {operador.nombreCompleto}
                    </p>
                  </div>
                ))
              )}
            </div>
            <button className="btn-cancel" onClick={() => setIsModalSeleccionOpen(false)}>
              Cancelar
            </button>
          </div>
        </div>
      )}

      {isConcluirModalOpen && selectedService && (
        <ModalConcluirServicio
          servicio={selectedService}
          onClose={() => {
            setIsConcluirModalOpen(false);
            window.location.reload();
          }}
          onUpdate={() => toast.success('Servicio actualizado correctamente.')}
        />
      )}
    </div>
  );
};

export default DailyOperatorsInfo;
